module.exports = __webpack_public_path__ + "static/media/bg-dark-icon.c888f758.svg";